export default "__VITE_PUBLIC_ASSET__d734c864__"